import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import Guid from '../utils/guid';


export default () => {
  return muster()
    .path('callback.getResponse', {
      call: async ({ req }, { get, set, call }) => {

        console.log("inside rmcallback muster");
        await set('callback.displayMsg', "");
        await set('app.user.cacheId', Date.now());

        let { screen, context, investmentIdeaId } = req.args[0].input;
        if(typeof investmentIdeaId === "undefined")
          investmentIdeaId = ""
        const [messages] = await getValues(get('i18n.messages'));
        var [portfolioId] = await getValues(get('app.user.selectedPortfolioId'));
        const guidStr = Guid();

        const [oReturn] = await getValues(get(`roster.data.callback.getResponseJson["${portfolioId}"]["${screen}"]["${context.split(' ').join('-')}"]["i${investmentIdeaId}"]["${guidStr}"]`));

        if (oReturn.$type == "error") {
          await set('callback.displayMsg', messages['app.rmcallback.errorMsg']);
          await set('callback.success', false);
          return;
        }

        const oResult = JSON.parse(oReturn);






        if (oResult.status && oResult.status.toUpperCase() == "SUCCESS") {
          await set('callback.displayMsg', messages['app.rmcallback.successMsg']);
          await set('callback.success', true);
        }
        else if (oResult.status == "RMCALLBACK_ALREADY_SEND_FOR_TODAY") {
          await set('callback.displayMsg', messages['app.rmcallback.alreadyReq']);
          await set('callback.success', false);
        }
        else {
          await set('callback.displayMsg', messages['app.rmcallback.errorMsg']);
          await set('callback.success', false);
        }

      },
    })

    .path('callback.setScreen', {
      call: async ({ req }, { get, set, call }) => {
        let screenPage = req.args[0];
        console.log("inside rmcallback muster");
        await set('callback.screen', screenPage);

      },
    })
    .path('callback.success', variable(false))
    .path('callback.screen', variable(""))
    .path('callback.pagename', variable(""))
    .path('callback.displayMsg', variable(""));
}

